<template>
    <v-app-bar app color="primary" dark>
      <v-container class="d-flex align-center">
        <v-app-bar-title>Dental Portal</v-app-bar-title>
        <v-spacer></v-spacer>
  
        <v-btn text to="/" exact>Ana Sayfa</v-btn>
        <v-btn text to="/announcements">Duyurular</v-btn>
        <v-btn text to="/news">Haberler</v-btn>      <v-btn text to="/educations">Eğitimler</v-btn> <v-spacer></v-spacer>
  
        <template v-if="!isAuthenticated">
          <v-btn text to="/login">Giriş Yap</v-btn>
          <v-btn text to="/register">Kayıt Ol</v-btn>
        </template>
  
        <template v-else>
           <v-btn text to="/announcements/new" icon>
               <v-icon>mdi-plus-box</v-icon>
               <v-tooltip activator="parent" location="bottom">Yeni İlan</v-tooltip>
           </v-btn>
           <v-btn text to="/favorites" icon> <v-icon>mdi-heart</v-icon>
               <v-tooltip activator="parent" location="bottom">Favoriler</v-tooltip>
           </v-btn>
           <v-btn text to="/notifications" icon> <v-badge content="3" color="error"> <v-icon>mdi-bell</v-icon>
               </v-badge>
                <v-tooltip activator="parent" location="bottom">Bildirimler</v-tooltip>
           </v-btn>
  
          <v-menu offset-y>
            <template v-slot:activator="{ props }">
              <v-btn text v-bind="props">
                <v-icon left>mdi-account</v-icon>
                {{ currentUser?.username }} <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list density="compact">
               <v-list-item to="/profile">
                  <v-list-item-title>Profil</v-list-item-title>
                   <template v-slot:prepend><v-icon>mdi-account-circle</v-icon></template>
              </v-list-item>
               <v-list-item to="/messages"> <v-list-item-title>Mesajlar</v-list-item-title>
                   <template v-slot:prepend><v-icon>mdi-email</v-icon></template>
              </v-list-item>
               <v-divider></v-divider>
              <v-list-item @click="logout">
                <v-list-item-title>Çıkış Yap</v-list-item-title>
                <template v-slot:prepend><v-icon color="error">mdi-logout</v-icon></template>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
  
      </v-container>
    </v-app-bar>
  </template>
  
  <script>
  import { mapGetters, mapActions } from 'vuex';
  
  export default {
    name: 'NavbarComponent',
    computed: {
      // Vuex getters'ı component'e map et
      ...mapGetters('auth', ['isAuthenticated', 'currentUser'])
    },
    methods: {
      // Vuex actions'ı component'e map et
      ...mapActions('auth', ['logout'])
    }
  };
  </script>
  
  <style scoped>
  /* Gerekirse Navbar'a özel stiller */
  .v-btn {
    margin: 0 4px;
  }
  </style>